<template>
	<div>
		<div class="page-title">
			<icon-font class="title-icon" type="icon-hunhemeiti" style="margin-right: 12px"/>
			<span>TikTok+ICBU</span>
		</div>
		<a-tabs v-model="activeKey" type="card" class="page-tabs">
			<!-- <a-tab-pane key="account" tab="Appsflyer账号"></a-tab-pane> -->
			<a-tab-pane key="data" tab="TikTok+ICBU数据"></a-tab-pane>
			<a-tab-pane key="export" tab="离线数据导入"></a-tab-pane>
		</a-tabs>
		<div v-if="activeKey === 'account'">
			<af-account code="TT-ICBU"></af-account>
		</div>
		<div v-if="activeKey === 'data'">
			<MediaData code="TT-ICBU"></MediaData>
		</div>
		<div v-if="activeKey === 'export'">
			<MediaDataExport code="TT-ICBU"></MediaDataExport>
		</div>
	</div>
</template>
<script>
import MediaData from "./components/mediaData.vue"
import afAccount from "./components/afAccount.vue"
import MediaDataExport from "./components/mediaDataExport.vue"

export default {
	name: 'ttAndIcbu',
	data() {
		return {
			activeKey: 'data',
			loading: false,
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10
			},
			data: [],
		}
	},
	methods: {
		openEC() {
			window.open('http://adpub.yeahtargeter.com/', '_blank')
		},
	},
	components: {
		MediaData,
		afAccount,
		MediaDataExport
	}
}
</script>
<style lang="less" scoped>
	.page-tabs {
		margin-top: 24px;
		padding-left: 24px;
		/deep/ .ant-tabs-bar {
			border-bottom: none;
		}
	}
</style>